import { TeamReview } from './TeamReview';
import { TeamReviewDecision } from './TeamReviewDecision';

export type ProjectEstimationBillingType = 'Hourly' | 'Fixed';

export interface ProjectEstimationSubmissionDto {
	workflowId?: string | null;
	nodeId?: string | null;
	projectId?: string | null;
	billingType: ProjectEstimationBillingType;
	estimatedHours?: number | null;
	hourlyRateUsd?: number | null;
	totalUsd: number;
	notes?: string | null;
	type?: string | null;
}

export class ProjectEstimationSubmission {
	userSubmissionId: string = '';
	nodeId: string = '';
	workflowId: string = '';
	projectId: string = '';
	billingType: ProjectEstimationBillingType = 'Fixed';
	estimatedHours: number | null = null;
	hourlyRateUsd: number | null = null;
	totalUsd: number = 0;
	notes: string = '';
	type: string = 'ProjectEstimationSubmission';
	status: TeamReviewDecision = TeamReviewDecision.NotYetStarted;
	teamReview: TeamReview | null = null;

	static fromDto(dto?: Partial<ProjectEstimationSubmissionDto> | any): ProjectEstimationSubmission {
		const submission = new ProjectEstimationSubmission();
		if (!dto) {
			return submission;
		}

		submission.userSubmissionId = dto.userSubmissionId ?? submission.userSubmissionId;
		submission.nodeId = dto.nodeId ?? submission.nodeId;
		submission.workflowId = dto.workflowId ?? submission.workflowId;
		submission.projectId = dto.projectId ?? submission.projectId;
		submission.billingType = dto.billingType === 'Hourly' ? 'Hourly' : 'Fixed';
		submission.estimatedHours = dto.estimatedHours ?? null;
		submission.hourlyRateUsd = dto.hourlyRateUsd ?? null;
		submission.totalUsd = Number(dto.totalUsd ?? 0);
		submission.notes = dto.notes ?? '';
		submission.type = dto.type ?? submission.type;
		submission.status = typeof dto.status === 'number'
			? dto.status
			: TeamReviewDecision.NotYetStarted;
		submission.teamReview = dto.teamReview ?? null;

		return submission;
	}

	toDto(): ProjectEstimationSubmissionDto {
		return {
			workflowId: this.workflowId,
			nodeId: this.nodeId,
			projectId: this.projectId,
			billingType: this.billingType,
			estimatedHours: this.estimatedHours,
			hourlyRateUsd: this.hourlyRateUsd,
			totalUsd: this.totalUsd,
			notes: this.notes,
			type: this.type,
		};
	}
}
